export type ReportSectionInfo = {
  id: string;
  name: string;
  element: HTMLElement;
  visibleRatio: number;
  visibleArea: number;
};

const getViewportHeight = (): number =>
  window.innerHeight || document.documentElement.clientHeight;

export const getReportSectionElements = (
  root: ParentNode = document
): HTMLElement[] =>
  Array.from(root.querySelectorAll<HTMLElement>('[data-report-section]'));

export const measureVisibleSections = (
  root: ParentNode = document
): ReportSectionInfo[] => {
  const viewportHeight = getViewportHeight();

  return getReportSectionElements(root).map((element) => {
    const rect = element.getBoundingClientRect();
    const visibleTop = Math.max(rect.top, 0);
    const visibleBottom = Math.min(rect.bottom, viewportHeight);
    const visibleHeight = Math.max(0, visibleBottom - visibleTop);
    const sectionHeight = Math.max(rect.height, 1);
    const visibleRatio = Math.min(1, visibleHeight / sectionHeight);
    const visibleArea = Math.max(0, visibleHeight * Math.max(rect.width, 0));
    const id = element.dataset.reportSection || element.id || 'unknown';
    const name =
      element.dataset.reportSectionName ||
      element.dataset.reportSection ||
      id;

    return {
      id,
      name,
      element,
      visibleRatio,
      visibleArea,
    };
  });
};

export const getMostVisibleSection = (
  root: ParentNode = document
): ReportSectionInfo | null => {
  const sections = measureVisibleSections(root).filter(
    (section) => section.visibleArea > 0
  );
  if (sections.length === 0) return null;

  return sections.reduce((best, current) =>
    current.visibleArea > best.visibleArea ? current : best
  );
};

export const getPrimaryVisibleSection = (
  root: ParentNode = document,
  minRatio = 0.5
): ReportSectionInfo | null => {
  const sections = measureVisibleSections(root).filter(
    (section) => section.visibleRatio >= minRatio
  );
  if (sections.length === 0) return null;

  return sections.reduce((best, current) =>
    current.visibleArea > best.visibleArea ? current : best
  );
};
